import type { ProductPromotion, PromotionSelectionInput, TabItemPromotionComponent } from '@/types';
import { validateAndResolvePromotion } from './promotionValidation';

export function resolvePromotionComponentsForDispatch(
  definition: ProductPromotion,
  selections: PromotionSelectionInput[] | undefined,
  productNameById: Map<string, string>
): TabItemPromotionComponent[] {
  const resolved = validateAndResolvePromotion(definition, selections ?? []);

  return resolved.map((comp, index) => ({
    id: `dispatch-comp-${index}`,
    tabItemId: 'dispatch',
    componentProductId: comp.componentProductId,
    quantity: comp.quantity,
    productName: productNameById.get(comp.componentProductId) ?? comp.componentProductId,
  }));
}
